module.exports = __webpack_public_path__ + "static/media/white-spinner.21dadb0d.gif";